export const TEAM_CREATE_REQUEST = "TEAM_CREATE_REQUEST"
export const TEAM_DELETE_REQUEST = "TEAM_DELETE_REQUEST"
export const TEAM_UPDATE_REQUEST = "TEAM_UPDATE_REQUEST"
export const TEAM_DETAILS_REQUEST = "TEAM_DETAILS_REQUEST"
export const GET_TEAMS_REQUEST = "GET_TEAMS_REQUEST"


